import ApiResetPassword from "../api/reset-password.js";
import Autentication from "../utils/autentication.js";
import NotificationModal from "../utils/initial_notification.js";



const ResendVerificationPresenter = {

	async init() {
		await this._setView();
		await this._giveEventResetPassword();
	},

	async _setView() {
		document.getElementById('resetPasswordEmail').focus();
		document.getElementById('main-content').classList.add('bg-gradient-primary');
		document.getElementById("main-content").style.paddingTop = "20px";
		document.getElementById('appbar').classList.add('d-none')
		document.getElementById('accordionSidebar').classList.add('d-none')
		document.getElementById('main-content').style.removeProperty("height");
	},

	async _giveEventResetPassword() {
		let countdownSeconds = 0
		let isTimerOn = false
		let timeoutId = null
		var defaultCoundown  = localStorage.getItem('countdownSeconds');
		var isIntervalOn = localStorage.getItem('interval_timer_is_on')
		if (isIntervalOn != undefined) {
			clearInterval(isIntervalOn);
		}
		if (defaultCoundown != undefined && defaultCoundown > 0) {
			isTimerOn = true
			countdownSeconds = defaultCoundown
			timeoutId = setInterval(() => {
				countdownSeconds--;
	
				localStorage.setItem('interval_timer_is_on',timeoutId);
				try {
					document.getElementById("btnResetPassword").innerHTML = `Tunggu ${countdownSeconds} detik lagi, untuk mengirim ulang`;
				} catch (error) {
					
				}
				
				localStorage.setItem('countdownSeconds', countdownSeconds);
				if (countdownSeconds <= 0) {
					clearInterval(timeoutId);
	
					localStorage.removeItem('countdownSeconds');
					document.getElementById("btnResetPassword").innerHTML = ` Kirim Link Verifikasi`;
					isTimerOn = false;

					localStorage.removeItem('interval_timer_is_on');
				}
			}, 1000);
		}

		const eventResetPassword = async (e) => {
			e.preventDefault();
			if (isTimerOn) {
				return
			}
				document.getElementById("btnResetPassword").innerHTML = `<div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>`
				const dataResetPassword = await ApiResetPassword.ResendVerification({
					email: document.getElementById('resetPasswordEmail').value
				});

				if (dataResetPassword.status_code != 202) {
					NotificationModal.show(`${dataResetPassword.message}`, 'error');
					document.getElementById("btnResetPassword").innerHTML = ` Kirim Link Verifikasi`;
				} else {
					NotificationModal.show(`${dataResetPassword.message}`, 'success');
					isTimerOn = true
					countdownSeconds = 60
					localStorage.setItem('countdownSeconds', countdownSeconds);
					timeoutId = setInterval(() => {
						countdownSeconds--;
						localStorage.setItem('interval_timer_is_on',timeoutId);
						try {
							document.getElementById("btnResetPassword").innerHTML = `Tunggu ${countdownSeconds} detik lagi, untuk mengirim ulang`;
						} catch (error) {
							
						}

						localStorage.setItem('countdownSeconds', countdownSeconds);
						if (countdownSeconds <= 0) {
							clearInterval(timeoutId);
							localStorage.removeItem('countdownSeconds');
							document.getElementById("btnResetPassword").innerHTML = ` Kirim Link Verifikasi`;
							isTimerOn = false;
							localStorage.removeItem('interval_timer_is_on');
						}
					}, 1000);
					
				}
			e.preventDefault();
		}
		document.getElementById('reset-password').addEventListener('submit', eventResetPassword);
		document.getElementById('btnLogin').addEventListener('click',()=>{
			this._navigateToLogin();
		});
	},

	_navigateToLogin(){
		window.location.hash = '#/login';
	},
}

export default ResendVerificationPresenter;
